import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { SharedCoreModule } from '../shared-core/shared-core.module';
import { AccountModule } from '../account/account.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule, 
    SharedModule, 
    SharedCoreModule, 
    AccountModule,
    ReactiveFormsModule
  ]
})
export class ProductModule { }
